
export const formatDateWithTime = (dateString) => {
  const options = { 
        year: "numeric", 
        month: "numeric",
        day: "numeric" ,
        hour12 : true,
        hour:  "numeric",
        minute: "numeric"
    }
  return new Date(dateString.length > 10 ? dateString.substring(0, dateString.length - 1) : dateString).toLocaleDateString("en-US", options)
}


export const formatDateWithTimeZ = (dateString) => {
  const options = { 
        year: "numeric", 
        month: "numeric",
        day: "numeric" ,
        hour12 : true,
        hour:  "numeric",
        minute: "numeric"
    }
  return new Date(dateString).toLocaleDateString("en-US", options)
}

export const formatTime = (dateString) => {
  const options = { 
        hour12 : true,
        hour:  "numeric",
        minute: "numeric"
    }
  return new Date(dateString).toLocaleTimeString("en-US", options)
}

export const formatDate = (dateString) => {
  const options = { 
        year: "numeric", 
        month: "numeric",
        day: "numeric" ,
    }
  return new Date(dateString).toLocaleDateString("en-US", options)
}


export const formatDateNew = (date) => {
  var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  var date = new Date(date)
  return date.getDate()+" "+monthNames[date.getMonth()]+" "+date.getFullYear();
}

export const formatDateNewMMMDDYYYY = (date) => {
  var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  var dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  
  var date = new Date(date)
  return dayNames[date.getDay()]+", "+ monthNames[date.getMonth()]+" "+date.getDate()+", "+date.getFullYear();
}

export const addMonths = (date, months) => {
  var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  var d = date.getDate();
  date.setMonth(date.getMonth() + +months);
  if (date.getDate() != d) {
    date.setDate(0);
  }
  return date.getDate()+" "+monthNames[date.getMonth()]+" "+date.getFullYear();
}